import React from "react";
import "./component.css";

type Props = {
  title?: string;
  className?: string;
  children?: React.ReactNode;
};

export default function NewestFrame({
  title = "NEWEST CARDS",
  className = "",
  children
}: Props) {
  return (
    <div className={`newest-frame ${className}`}>
      <div className="newest-frame__inner">
        <div className="newest-rows">{children}</div>
      </div>
    </div>
  );
}
